import { render, staticRenderFns } from "./DaysSlider.vue?vue&type=template&id=ca77a686&scoped=true&"
import script from "./DaysSlider.vue?vue&type=script&lang=js&"
export * from "./DaysSlider.vue?vue&type=script&lang=js&"
import style0 from "./DaysSlider.vue?vue&type=style&index=0&id=ca77a686&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca77a686",
  null
  
)

export default component.exports